var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container my-6"},[_c('h3',{staticClass:"my-6"},[_vm._v(" Passwort vergessen? ")]),_c('RasmusForgotPasswordForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }